
export const carouselData = [
    {
        id: 1,
        label:'Avocado toast with egg',
        image:'https://jeanetteshealthyliving.com/wp-content/uploads/2015/01/Smashed-Avocado-Toast-with-Smoked-Salmon-and-Egg-3.jpg',
        url:'https://jeanetteshealthyliving.com/smashed-avocado-toast-with-egg-and-smoked-salmon/'
    },
    {
        id: 2,
        label:'Scrambled egg panini',
        image:'https://img.sndimg.com/food/image/upload/f_auto,c_thumb,q_55,w_860,ar_3:2/v1/img/recipes/88/37/5/pic9YoDK1.jpg',
        url:'https://www.food.com/recipe/breakfast-scrambled-egg-panini-88375'
    },
    {
        id: 3,
        label:'Breakfast salad',
        image:'https://i0.wp.com/sevenlayercharlotte.com/wp-content/uploads/2018/01/IMG_9417.jpg?resize=768%2C1024&ssl=1',
        url:'https://sevenlayercharlotte.com/2018/01/03/breakfast-salad/'
    },
    {
        id: 4,
        label:'Chia seed pudding',
        image:'https://www.eatingwell.com/thmb/m01_fIHk3lfzRWismyCAgWyEoHM=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/EWL-RM-chia-seed-pudding-hero-0359-5d8095204fa84a0a944c937dd11d1550.jpg',
        url:'https://www.eatingwell.com/chia-seed-pudding-8430793'
    },
    {
        id: 5,
        label:'Banana-oat pancakes',
        image:'https://www.eatingwell.com/thmb/-D9U3Mn6WA8dMwGHWmNplF-DJLU=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/JF_BananaOatPancakes_3x2_1b_13245-f2042b694d674f26a8932f63d71c6383.jpg',
        url:'https://www.eatingwell.com/best-banana-oat-pancakes-8408692'
    },
    {
        id: 6,
        label:'Tropical parfait',
        image:'https://d2vsf1hynzxim7.cloudfront.net/production/media/21384/responsive-images/foodnetwork-image-627bbd21-62ad-48a8-af4e-c05a8f716301___default_572_429.jpeg',
        url:'https://foodnetwork.co.uk/recipes/tropical-breakfast-parfait'
    },
    {
        id: 7,
        label:'Bacon spinach toast',
        image:'https://www.marthastewart.com/thmb/zgmyWkXErtTmOazIyoGq_lSWIfw=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/med106560_0311_bag_egg_bacon_toast_vert-8e196cc66df943c0a0ab5817d2bf469b.jpgitokAakJcrqh',
        url:'https://www.marthastewart.com/340632/egg-bacon-toasts-with-onions-and-spinach'
    },
    {
        id: 8,
        label:'French lentil caviar salad',
        image:'https://images.food52.com/3_qnS2_54irKJj3s8Cb2cpVM5Cw=/1008x672/filters:format(webp)/32531884-9cd8-48fb-926b-5eae45787e00--P1010522.jpg',
        url:'https://food52.com/recipes/11996-french-lentil-caviar-salad-with-a-poached-egg'
    },
    {
        id: 9,
        label: 'Mexican quinoa bowl',
        image: 'https://d2vsf1hynzxim7.cloudfront.net/production/media/17184/responsive-images/foodnetwork-image-461b25d6-9804-4424-bcdc-50051342676a___default_382_287.jpg',
        url: 'https://foodnetwork.co.uk/recipes/mexican-quinoa-breakfast-bowl'
    }
    ]